import { Box, Heading, Text, VStack, UnorderedList, ListItem } from '@chakra-ui/react';
import { useEffect } from 'react';

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <VStack p={[5, 10, 20]} spacing={8} align="start" maxW="1200px" mx="auto">
        <Heading color="#0C727E" size="2xl">Privacy Policy</Heading>
        
        <Text fontSize="lg">
          This Privacy Policy brings to your notice that the website (www.dilatelabs.com), its sub-domains and all related applications and services are owned and operated by Dilatelabs.com.
        </Text>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Applicability</Heading>
          <Text>Our Privacy Policy is applicable to:</Text>
          <UnorderedList spacing={2} pl={5}>
            <ListItem>A healthcare service provider who agrees to be listed with Dilatelabs</ListItem>
            <ListItem>Users (You) or your relatives/attendants who use our services</ListItem>
            <ListItem>Anyone who uses our services in any form</ListItem>
            <ListItem>Third parties (such as AdRoll) who may place cookies on browsers for targeted advertising</ListItem>
          </UnorderedList>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Location Data Collection</Heading>
          <Text>
            Our applications (Dlabs Rider) collect precise and approximate location data to enable real-time tracking of sample pickups and deliveries. 
          </Text>
          <UnorderedList spacing={2} pl={5}>
            <ListItem>
              <strong>Background Location:</strong> The Rider application collects location data even when the app is closed or not in use, specifically when a rider is on an active delivery task. This is necessary to provide real-time tracking to customers and lab administrators.
            </ListItem>
            <ListItem>
              <strong>Purpose:</strong> This data is used to calculate delivery times, monitor medical sample safety, and ensure efficient route management.
            </ListItem>
            <ListItem>
              <strong>Sharing:</strong> Location data is shared with the specific patient/customer whose sample is being handled and with our internal logistics management system.
            </ListItem>
          </UnorderedList>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Introduction</Heading>
          <Text>
            This policy gives information about the type and amount of information collected from the Users, including sensitive personal data or information; the purpose of collection and modes of usage of such information; and how Dilatelabs.com will use such information.
          </Text>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Information We Collect</Heading>
          <Text>Information collected by us may include:</Text>
          <UnorderedList spacing={2} pl={5}>
            <ListItem>Name, Login ID, and Password</ListItem>
            <ListItem>Contact Information (Email, Address, Phone Numbers)</ListItem>
            <ListItem>Demographic Data (Gender, Date of Birth, Pin Code)</ListItem>
            <ListItem>IP Address, Operating System, Browser Details</ListItem>
            <ListItem>Historic data regarding your usage of our services</ListItem>
            <ListItem>Medical information and credentials</ListItem>
            <ListItem>Financial and payment-related data</ListItem>
          </UnorderedList>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Use of Information</Heading>
          <Text>We reserve the right to use information provided for:</Text>
          <UnorderedList spacing={2} pl={5}>
            <ListItem>Publishing on the website/mobile application</ListItem>
            <ListItem>Contacting you for offering new products/services</ListItem>
            <ListItem>Feedback, analysis, and reporting</ListItem>
            <ListItem>Legitimate business purposes with partners</ListItem>
          </UnorderedList>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Data Security</Heading>
          <Text>
            Recipients of your personal data may be located in any country. We take all necessary precautions to protect your personal information. However, Dilatelabs.com is not responsible for any breach of security or for any actions of any third parties that are beyond our reasonable control.
          </Text>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Data Retention</Heading>
          <Text>
            We retain your personal and sensitive data (such as name, contact details, medical records, and location history) only for as long as your account remains active or as needed to provide you with our services. Specifically:
          </Text>
          <UnorderedList spacing={2} pl={5}>
            <ListItem><strong>Profile and Transaction Data:</strong> Retained as long as your account is active, and up to 5 years after account deletion to comply with legal, financial, and medical record-keeping regulations.</ListItem>
            <ListItem><strong>Location Data:</strong> Location data collected for delivery tracking is retained for up to 90 days after delivery completion, after which it is deleted or anonymized.</ListItem>
          </UnorderedList>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Data Deletion and Account Deletion</Heading>
          <Text>
            We respect your right to control your personal data and provide easy ways to request deletion of your account and associated information:
          </Text>
          <UnorderedList spacing={2} pl={5}>
            <ListItem><strong>In-App Deletion:</strong> You can request immediate deletion of your account and personal data directly within the app by navigating to <strong>Profile &gt; Delete Account</strong>.</ListItem>
            <ListItem><strong>Email Request:</strong> You can also send an email request for account and data deletion to <strong>info@dilatelabs.com</strong>.</ListItem>
          </UnorderedList>
          <Text>
            Upon account deletion, all personal data, login credentials, and historical logs will be permanently deleted from our active databases within 30 days, except where we are required by law or regulations to retain certain records.
          </Text>
        </VStack>

        <VStack align="start" spacing={4} width="100%">
          <Heading size="md" color="teal.700">Contact Us</Heading>
          <Text>
            If you have any questions or concerns about our privacy practices, please contact us at:
            <br />
            <strong>Email:</strong> info@dilatelabs.com
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
}
